import React, { useState, useCallback } from 'react';

import classNames from 'classnames/bind';
import styles from './Dim.scss';
const cx = classNames.bind(styles);

const Dim = React.memo((props = {}) => {
  const { style = {} } = props;
  const [toggle, setToggle] = useState(false);

  const handleMouseDown = useCallback(() => {
    if (props.onClick) {
      setToggle(!toggle);
    }
  }, [toggle]);

  const handleMouseUp = useCallback(
    e => {
      const className = e.target.className;
      if (props.onClick && toggle) {
        setToggle(false);
        if (
          className &&
          className.match('dim-wrapper') &&
          className.match('dim-wrapper').length
        ) {
          props.onClick(e);
        }
      }
    },
    [toggle],
  );

  // const handleClick = useCallback(
  //   e => {
  //     if (toggle) {
  //       props.onClick(e);
  //     }
  //   },
  //   [toggle],
  // );

  return (
    <div
      className={cx('Dim', 'dim-wrapper')}
      // onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      style={style}
    >
      {props.children}
    </div>
  );
});

export default Dim;
